// extracted by mini-css-extract-plugin
export default {"insurance":"Insurance_insurance__UsE6O","title":"Insurance_title__4zPOU","th-td":"Insurance_th-td__eaxHW"};